"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCTION_HOSTS = void 0;
exports.PRODUCTION_HOSTS = {
    catalog: 'https://vod.wix.com',
    catalogEditorX: 'https://vod.editorx.com',
    files: 'https://vod-meta.wix.com',
    filesEditorX: 'https://vod-meta.editorx.com',
    image: 'https://images-vod.wixmp.com',
    wixFiles: 'https://files.wix.com/files',
    paypal: 'https://dgs.wixapps.net',
    statsCollector: 'https://video-counters.wix.com',
    pixWix: 'https://pix.wix.com/services',
    manage: 'https://manage.wix.com',
    vodServer: 'https://vod-server.wix.com',
};
//# sourceMappingURL=hosts.js.map